import { t } from '@/features/i18n/utils';
import { ProjectBreadcrumbs } from '@/features/projects/components/project-breadcrumbs';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderBackButton, HeaderChatButton } from '@/ui/components/header';
import { H1 } from '@/ui/components/heading';
import {
  Main,
  MainContainer,
  MainHeader,
  MainHeaderBackButton,
  MainScrollArea,
} from '@/ui/components/main';
import { Sidenav, SidenavItem, SidenavLink, SidenavList } from '@/ui/components/sidenav';
import { Settings02Icon } from '@hugeicons-pro/core-stroke-rounded';
import { Icon } from '@/ui/components/icon';

export const Route = createFileRoute('/_authed/project/$projectId/settings')({
  component: RouteComponent,
});

function RouteComponent() {
  const { projectId } = Route.useParams();

  return (
    <Main>
      <Header>
        <HeaderBackButton />
        <ProjectBreadcrumbs>
          <BreadcrumbPage>
            <Icon icon={Settings02Icon} />
            {t({ en: 'Settings', nb: 'Innstillinger' })}
          </BreadcrumbPage>
        </ProjectBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <MainScrollArea>
        <MainHeader className="max-md:hidden">
          <H1>
            <MainHeaderBackButton />
            {t({ en: 'Settings', nb: 'Innstillinger' })}
          </H1>
        </MainHeader>
        <div className="flex flex-col @3xl:flex-row">
          <Sidenav className="@3xl:sticky top-0 h-fit">
            <SidenavList className="p-4">
              <SidenavItem>
                <SidenavLink to={'/project/$projectId/settings'} params={{ projectId }}>
                  {t({ en: 'General', nb: 'Generelt' })}
                </SidenavLink>
              </SidenavItem>
            </SidenavList>
          </Sidenav>
          <MainContainer>
            <Outlet />
          </MainContainer>
        </div>
      </MainScrollArea>
    </Main>
  );
}
